import { Box, FormLabel, SystemStyleObject } from '@chakra-ui/react';
import { ChakraStylesConfig, CreatableSelect } from 'chakra-react-select';
import _ from 'lodash';
import showMessage from 'providers/NoticeProvider/showMessage';
import React, { KeyboardEventHandler } from 'react';

const chakraStyles: ChakraStylesConfig = {
    // container: (provided, state) => ({
    //     ...provided,
    //     minHeight: '120px',
    // }),
    valueContainer: (provided, state) => ({
        ...provided,
        minHeight: '120px',
        maxHeight: '120px',
        alignItems: 'flex-start',
        padding: '16px',
        flexDirection: 'column',
        overflowY: 'auto',
        flexWrap: 'nowrap',
    }),
    // dropdownIndicator: (prev, { selectProps }) => ({
    //     ...prev,
    //     transform: `rotate(${selectProps.menuIsOpen ? -180 : 0}deg)`,
    // }),
    // menuList: (provided, state) => ({
    //     ...provided,
    //     borderRadius: '8px',
    //     boxShadow: '0px 24px 48px -12px rgba(16, 24, 40, 0.18)',
    //     borderColor: 'gray.100',
    //     padding: '12px',
    // }),
    // option: (prev, state) => ({
    //     ...prev,
    //     height: '40px',
    //     color: state.isSelected ? 'brand.500' : undefined,
    // }),
    // singleValue: (provided, state) => ({
    //     ...provided,
    //     color: 'red',
    // }),
};
const components: any = {
    DropdownIndicator: null,
};

export type TOption = {
    label: string;
    value: string;
};

const createOption = (label: string) => ({
    label,
    value: label,
});

type TProps = {
    // label: string;
    value: TOption[];
    setValue: (value: React.SetStateAction<TOption[]>) => void;
    // options: TOption[];
    sx?: SystemStyleObject;
};
const validateEmail = (email: string) => {
    return email.match(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/);
};

const InviteMembersDropdown = ({
    // label,
    value,
    setValue,
    sx,
}: TProps) => {
    const [inputValue, setInputValue] = React.useState('');

    const handleKeyDown: KeyboardEventHandler = event => {
        if (!inputValue) return;
        switch (event.key) {
            case 'Enter':
            case 'Tab':
                console.log(value);

                setValue(prev => {
                    const newItem = createOption(inputValue);
                    const cond = !_.some(prev, newItem);
                    console.log(cond, newItem);

                    if (cond && validateEmail(inputValue)) {
                        setInputValue('');
                        event.preventDefault();
                        return [...prev, newItem];
                    } else {
                        if (!cond) {
                            showMessage('Duplicate email address', 'error');
                        } else {
                            showMessage('Invalid email address', 'error');
                        }
                        return prev;
                    }
                });
        }
    };

    return (
        <Box sx={sx}>
            <FormLabel display="flex" fontSize="md" fontWeight="700" color="gray.900" mb="8px">
                Email
            </FormLabel>
            <CreatableSelect
                variant="auth"
                components={components}
                inputValue={inputValue}
                isClearable
                isMulti
                menuIsOpen={false}
                onChange={newValue => setValue(newValue as any)}
                onInputChange={newValue => setInputValue(newValue)}
                onKeyDown={handleKeyDown}
                placeholder="Type email address and press enter..."
                value={value}
                chakraStyles={chakraStyles}
            />
        </Box>
    );
};

export default InviteMembersDropdown;
